import Vue from 'vue'
import Vuex from 'vuex'
import { setStorage,getStorage } from "@/common/storage";
import router from "@/router"
Vue.use(Vuex)

export default new Vuex.Store({
  namespaced:true,
  state: {
    token:null,
    school_id:null,
    planList:null
  },
  getters: {
  },
  mutations: {
    setData(state,data){
      console.log(data);
      state.token = data.token
      state.school_id = data.school_id
      state.planList = JSON.stringify(data.list)
      //将常用数据存入本地localStorage
      setStorage('token',data.token)
      setStorage('school_id',data.school_id)
      
    }
  },
  actions: {
      // 登录成功之后的处理
      async  recurrence(context,data){
        // console.log(data.data);
       await context.commit('setData',data)
      router.push("/planList")
    }
  },
  modules: {

  }
})
